// 首页 活动页
const Index = r => require.ensure(
  [],
  () => r(require('@/components/index')),
  'Index'
)
// 首页
const Home = r => require.ensure(
  [],
  () => r(require('@/components/index/home')),
  'Home'
)
// 首页的一些详情
const IndexDetails = r => require.ensure(
  [],
  () => r(require('@/components/index/details/index')),
  'IndexDetails'
)
// 联系我们
const ContactUs = r => require.ensure(
  [],
  () => r(require('@/components/index/contact-us')),
  'ContactUs'
)

// 联系我们
const AboutUs = r => require.ensure(
  [],
  () => r(require('@/components/index/about-us')),
  'ContactUs'
)

// 优惠券列表
const MyCouponList = r => require.ensure(
  [],
  () => r(require('@/components/bloom-user/personal-center/coupon-list')),
  'MyCouponList'
)

// 优惠券列表
const Messages = r => require.ensure(
  [],
  () => r(require('@/components/index/messages')),
  'MyCouponList'
)
// 优惠券列表
const MessagesList = r => require.ensure(
  [],
  () => r(require('@/components/index/messages/sonPage')),
  'MessagesSon'
)
const AcademicDetails = r => require.ensure(
  [],
  () => r(require('@/components/index/messages/AcademicDetails')),
  'MessagesSon'
)
// 优惠券列表
const MyOrderList = r => require.ensure(
  [],
  () => r(require('@/components/bloom-user/personal-center/order-list')),
  'MyOrderList'
)
// 教练端证书分享页面
const certificationShare = r => require.ensure(
  [],
  () => r(require('@/components/index/certification-share')),
  'certificationShare'
)
// 教练端证书分享页面
const certificationShare2 = r => require.ensure(
  [],
  () => r(require('@/components/index/certification-share2')),
  'certificationShare2'
)
// 教练端证书分享页面 studentShare
const studentShare = r => require.ensure(
  [],
  () => r(require('@/components/index/messages/student-share')),
  'studentShare'
)
const accountManagement = r => require.ensure(
  [],
  () => r(require('@/components/accountManagement/accountManagement')),
  'MyOrderList'
)
export default [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/IndexDetails/ProjectList',
    name: 'Index',
    component: Index
  },
  // 首页里面的一些详情列表
  {
    path: '/IndexDetails/:listName',
    name: 'IndexDetails',
    component: IndexDetails
  },
  {
    path: '/AboutUs',
    name: 'AboutUs',
    component: AboutUs
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/ContactUs',
    name: 'ContactUs',
    component: ContactUs
  },
  {
    path: '/MyCouponList',
    name: 'MyCouponList',
    component: MyCouponList
  },
  {
    path: '/Messages',
    name: 'Messages',
    component: Messages
  },
  {
    path: '/MessagesList',
    name: 'MessagesList',
    component: MessagesList
  },
  {
    path: '/AcademicDetails',
    name: 'AcademicDetails',
    component: AcademicDetails
  },
  {
    path: '/accountManagement',
    name: 'accountManagement',
    component: accountManagement
  },
  {
    path: '/MyOrderList',
    name: 'MyOrderList',
    component: MyOrderList
  },
  {
    path: '/certificationShare',
    name: 'certificationShare',
    component: certificationShare
  },
  {
    path: '/certificationShare2',
    name: 'certificationShare2',
    component: certificationShare2
  },
  {
    path: '/studentShare',
    name: 'studentShare',
    component: studentShare
  }
]



// WEBPACK FOOTER //
// ./src/router/sub-route/index.js